import { render, staticRenderFns } from "./LeaveApplicationReport.vue?vue&type=template&id=3a51a1b8"
import script from "./LeaveApplicationReport.vue?vue&type=script&lang=js"
export * from "./LeaveApplicationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports